const invertedMessages = {
  // ── PreLaunchDashboard states ────────────────────────────────────────────
  'Analysis in Progress': 'certs.prelaunch.dashboard.running.title',
  'Re-analyzing…': 'certs.prelaunch.dashboard.reanalyzing',
  'This page will automatically refresh when the analysis completes.':
    'certs.prelaunch.dashboard.running.hint',
  'Analysis Failed': 'certs.prelaunch.dashboard.failed.title',
  'An unexpected error occurred.': 'certs.prelaunch.dashboard.failed.default',
  'Retrigger Analysis': 'certs.prelaunch.dashboard.retrigger',
  'Retriggering…': 'certs.prelaunch.dashboard.retriggering',
  'Loading report…': 'certs.prelaunch.dashboard.loading',

  // ── Aggregate count cards ────────────────────────────────────────────────
  'Aggregate Counts': 'certs.prelaunch.dashboard.aggregate',
  Users: 'certs.prelaunch.dashboard.users',
  Accounts: 'certs.prelaunch.dashboard.accounts',
  Entitlements: 'certs.prelaunch.dashboard.entitlements',
  Roles: 'certs.prelaunch.dashboard.roles',
  Certifiers: 'certs.prelaunch.dashboard.certifiers',
  Applications: 'certs.prelaunch.dashboard.applications',

  // ── Section headers ──────────────────────────────────────────────────────
  'Data Quality Insights': 'certs.prelaunch.dashboard.dq',
  'Risk Analysis': 'certs.prelaunch.dashboard.risk',
  'Certifier Data Quality Insights': 'certs.prelaunch.dashboard.certifier.dq',
  'Access Lifecycle Metrics': 'certs.prelaunch.dashboard.type.dq',
  'Access Risk Indicators': 'certs.prelaunch.dashboard.type.risk',

  // ── MetricTable column headers ───────────────────────────────────────────
  Metric: 'certs.prelaunch.metric.table.metric',
  Count: 'certs.prelaunch.metric.table.count',

  // ── Phase labels ─────────────────────────────────────────────────────────────────
  'Data Quality': 'certs.prelaunch.phase.data_quality',
  Finalizing: 'certs.prelaunch.phase.finalizing',

  // ── Data Quality metric labels (all campaign types) ──────────────────────
  'Missing Emails': 'certs.prelaunch.metric.missing_emails',
  'No Manager': 'certs.prelaunch.metric.no_manager',
  'Inactive Users': 'certs.prelaunch.metric.inactive_users',
  'Missing Department': 'certs.prelaunch.metric.missing_department',
  'Orphan Accounts': 'certs.prelaunch.metric.orphaned_accounts',
  'Disabled Endpoints': 'certs.prelaunch.metric.disabled_endpoints',
  'Inactive Manager': 'certs.prelaunch.metric.inactive_manager',
  'Users With Inactive Accounts':
    'certs.prelaunch.metric.users_with_inactive_accounts',
  'Default Certifier Usage': 'certs.prelaunch.metric.default_certifier',
  'Duplicate Records': 'certs.prelaunch.metric.duplicate_records',

  // ── Risk Analysis metric labels (all campaign types) ─────────────────────
  'Dormant Accounts': 'certs.prelaunch.metric.dormant_accounts',
  'Privileged Accounts': 'certs.prelaunch.metric.privileged_accounts',
  'SOD Violations': 'certs.prelaunch.metric.sod_violations',
  'Locked Accounts': 'certs.prelaunch.metric.locked_accounts',
  'Entitlements Without Metadata':
    'certs.prelaunch.metric.entitlements_without_metadata',

  // ── Certifier Data Quality metric labels (all campaign types) ────────────
  'Certifiers With No Email': 'certs.prelaunch.metric.certifiers_no_email',
  'Inactive Certifiers': 'certs.prelaunch.metric.inactive_certifiers',
  'Default Certifier Inactive':
    'certs.prelaunch.metric.default_certifier_inactive',
  'Default Certifier No Email':
    'certs.prelaunch.metric.default_certifier_no_email',
  'Reassignee With No Email': 'certs.prelaunch.metric.reassignee_no_email',

  // ── Access Lifecycle Metrics — User Manager (type 2) ─────────────────────
  'Users With No Entitlements':
    'certs.prelaunch.metric.users_with_no_entitlements',
  'Access Certified > 30 Days Ago':
    'certs.prelaunch.metric.access_last_certified_30',
  'Access Certified > 60 Days Ago':
    'certs.prelaunch.metric.access_last_certified_60',
  'Access Certified > 90 Days Ago':
    'certs.prelaunch.metric.access_last_certified_90',
  'Access Never Certified': 'certs.prelaunch.metric.access_never_certified',

  // ── Access Risk Indicators — User Manager (type 2) ───────────────────────
  'High Risk Entitlements': 'certs.prelaunch.metric.high_risk_entitlements',
  'High SOX-Critical Entitlements':
    'certs.prelaunch.metric.high_sox_critical_entitlements',
  'High SYS-Critical Entitlements':
    'certs.prelaunch.metric.high_sys_critical_entitlements',
  'High Privilege Entitlements':
    'certs.prelaunch.metric.high_privilege_entitlements',
  'High Risk Roles': 'certs.prelaunch.metric.high_risk_roles',
  'High SOX-Critical Roles': 'certs.prelaunch.metric.high_sox_critical_roles',
  'High SYS-Critical Roles': 'certs.prelaunch.metric.high_sys_critical_roles',
  'High Privilege Roles': 'certs.prelaunch.metric.high_privilege_roles',
  'Roles with No Active Entitlements':
    'certs.prelaunch.metric.roles_no_active_entitlements',
  'Roles With Inherent SOD': 'certs.prelaunch.metric.roles_with_inherent_sod',
  'Accounts With SOD': 'certs.prelaunch.metric.accounts_with_sod',
  'Entitlements Causing SOD': 'certs.prelaunch.metric.entitlements_causing_sod',

  // ── Access Lifecycle Metrics — Entitlement Owner (type 1) ────────────────
  'Parent Entitlements': 'certs.prelaunch.metric.parent_entitlements',
  'Child Entitlements': 'certs.prelaunch.metric.child_entitlements',
  'Entitlements With No Accounts':
    'certs.prelaunch.metric.entitlements_no_accounts',
  'Orphan Accounts With Entitlements':
    'certs.prelaunch.metric.orphan_accounts_with_entitlements',
  'Inactive Entitlements': 'certs.prelaunch.metric.inactive_entitlements',
  'Users On Risky Entitlements':
    'certs.prelaunch.metric.users_on_risky_entitlements',

  // ── Access Risk Indicators — Entitlement Owner (type 1) ──────────────────
  'Entitlements With SOD': 'certs.prelaunch.metric.entitlements_with_sod',

  // ── Access Lifecycle Metrics — Service Account (type 6) ──────────────────
  'Distinct Account Types': 'certs.prelaunch.metric.distinct_account_types',
  'Accounts With No Entitlements':
    'certs.prelaunch.metric.accounts_no_entitlements',
  'Accounts with All Inactive Entitlements':
    'certs.prelaunch.metric.accounts_all_inactive_entitlements',
  'Application Roles In Scope':
    'certs.prelaunch.metric.application_roles_in_scope',
};

export default invertedMessages;
